import axios from 'axios';
import Cookies from 'js-cookie';
import { adminBaseUrl } from './baseUrl';

const apiClient = axios.create({
	baseURL: adminBaseUrl,
	headers: { Authorization: `Bearer ${Cookies.get('token')}` },
});

export default apiClient;
